<template>
  <button
    :class="className"
    @click="onClick"
    ref="container">
    <sprite
      :id="`category/${sprite}`"
      class="chip__sprite" />
    <span class="chip__label">
      {{ label }}
    </span>
  </button>
</template>

<script>
import Sprite from "/shared/sprite";
import bemBlockModifiers from "/utils/bem-block-modifiers";

export default {
  components: { Sprite },
  props: {
    sprite: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    modifiers: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    className() {
      const modifiers = this.modifiers.slice(0);

      if (this.active) {
        modifiers.push("active");
      }

      return bemBlockModifiers("chip", modifiers);
    }
  },
  methods: {
    onClick(e) {
      e.preventDefault();
      this.$emit("click", this.slug);
    }
  }
};
</script>

<style lang="scss">
.chip {
  display: flex;
  align-items: center;
  padding: 10px 18px; /* stylelint-disable-line unit-blacklist */

  color: $blue-dark;

  background-color: $white;
  border: 2px solid $white;
  border-radius: 4px;

  cursor: pointer;

  /* stylelint-disable-next-line selector-nested-pattern */
  &:hover,
  &--active {
    border-color: $green;
  }

  &--grey-bg {
    background-color: $pale-mint-grey;
  }

  &__sprite {
    display: block;
    width: $basex3;
    height: $basex3;
    margin-right: $base;

    color: $blue;
  }

  &__label {
    display: block;

    white-space: nowrap;
  }
}
</style>
